module.exports = __webpack_public_path__ + "static/img/usage-guide-video-button.606b1d8.png";